import {
  borderWidth,
  colors,
  radius,
  shadows,
  sizes,
  spacings,
} from "@/assets/themes";
import { Block, Body14, Body16, Icon } from "@/components";
import { YOOJO_COVER_PRICE } from "@/utils";
import polyglot from "@/utils/polyglot";

const ADVANTAGES = [
  {
    icon: "credit-card",
    title: polyglot.t("pass.advantage_recurring.zero_fees", {
      value: polyglot.toSmartCurrency(0, { noDecimal: true }),
    }),
    subtitle: polyglot.t("pass.advantage_recurring.zero_fees_description"),
  },
  {
    icon: "user-check",
    title: polyglot.t("pass.advantage_recurring.coupon_on_jobs"),
    subtitle: polyglot.t("pass.advantage_recurring.coupon_on_jobs_description"),
  },
  {
    icon: "refresh",
    title: polyglot.t("pass.advantage_recurring.schedule"),
    subtitle: polyglot.t("pass.advantage_recurring.schedule_description"),
  },
  {
    icon: "double-arrow",
    title: polyglot.t("pass.advantage_recurring.deferred_payment"),
    subtitle: polyglot.t(
      "pass.advantage_recurring.deferred_payment_description_alt"
    ),
  },
  {
    icon: "calendar-times",
    title: polyglot.t("pass.advantage_recurring.without_commitment"),
    subtitle: polyglot.t(
      "pass.advantage_recurring.without_commitment_description"
    ),
  },
  {
    icon: "shield-half",
    title: polyglot.t("pass.advantage_recurring.yoojo_cover_title"),
    subtitle: polyglot.t("recurring_advantages.damage_coverage", {
      amount: polyglot.toSmartCurrency(YOOJO_COVER_PRICE, {
        noDecimal: true,
      }),
    }),
  },
];

const MembershipAdvantages = ({ backgroundColor = colors.background }) => (
  <Block display="grid" gridCols="1fr 1fr" gap={spacings.m}>
    {ADVANTAGES.map((advantage) => (
      <Block
        backgroundColor={backgroundColor}
        key={`membership-advantage-${advantage.icon}`}
        borderRadius={radius.ml}
        overflow="hidden"
        display="flex"
        flexDirection="column"
        gap={spacings.s}
        padding={{ xs: spacings.sm, md: spacings.m }}
      >
        <Block
          backgroundColor={colors.background}
          boxShadow={shadows.xs}
          border={`${borderWidth.s} solid ${colors.border}`}
          borderRadius={radius.ml}
          width={sizes.size36}
          height={sizes.size36}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon.Large name={advantage.icon} color={colors.primary} />
        </Block>
        <Block display="flex" flexDirection="column" gap={spacings.xs}>
          <Body16 strong>{advantage.title}</Body16>
          <Body14 color={colors.muted}>{advantage.subtitle}</Body14>
        </Block>
      </Block>
    ))}
  </Block>
);

export default MembershipAdvantages;
